/// Utilities for formatting dimensions for display, including snapping to common increments.

import { debugLog } from "./utils";
import { SNAP_TO_INCREMENTS } from "./constants";

const __DEBUG = false;

/* Snap `value` to whichever multiple from SNAP_TO_INCREMENTS is closest. */
export const snapToIncrements = (value) => {
  if (__DEBUG) debugLog("[snapToIncrements] Input:", value);
  let bestValue = value;
  let bestDiff = Infinity;

  for (const inc of SNAP_TO_INCREMENTS) {
    const candidate = Math.round(value / inc) * inc;
    const diff = Math.abs(candidate - value);
    if (diff < bestDiff) {
      bestDiff = diff;
      bestValue = candidate;
    }
  }
  const snapped = Number(bestValue.toFixed(3));
  if (__DEBUG) debugLog("[snapToIncrements] snapped to:", snapped);
  return snapped;
};

/* Format a number with up to 3 decimals, removing trailing zeroes/dots. */
const formatDecimal = (val) => {
  let s = val.toFixed(3);
  s = s.replace(/(\.\d*?)0+$/, "$1");
  s = s.replace(/\.$/, "");
  return s;
};

/* Snap height and width to increments, return string of height × width. */
export const snapAndFormatDimensions = (rawWidth, rawHeight) => {
  const w = snapToIncrements(rawWidth);
  const h = snapToIncrements(rawHeight);
  return `${formatDecimal(w)} &times; ${formatDecimal(h)}`;
};
